import { AxiosInstance, AxiosResponse } from 'axios';

const rejectAndCleanUp = (logout: () => void, error: any) => {
  logout();

  return Promise.reject(error);
};

const responseSuccessInterceptor = (response: AxiosResponse) => response;

const responseErrorInterceptor = (logout: () => void) => (error: any) => {
  if (!error.config.url.includes('login') && error.response.status === 401) {
    logout();

    return rejectAndCleanUp(logout, error);
  }

  throw error;
};

export default function setupInterceptors(
  axios: AxiosInstance,
  logout: () => void
) {
  axios.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor(logout)
  );
}
